import TrackerFilterPopoverGrid from './TrackerFilterPopoverGrid';
import { Box, Typography } from '@mui/material';
import DatePickerInputField from '../../shared/inputs/DatePickerInputField';

interface TrackerFilterDateSelectionProps {
  label: string;
  startDate: Date | null;
  endDate: Date | null;
  onStartDateSelection: (date: Date | null) => void;
  onEndDateSelection: (date: Date | null) => void;
}

export default function TrackerFilterDateSelection(props: TrackerFilterDateSelectionProps) {
  const { label, startDate, endDate, onStartDateSelection, onEndDateSelection } = props;

  return (
    <TrackerFilterPopoverGrid>
      {label}
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
        <Typography fontSize="12px">From</Typography>
        <DatePickerInputField
          textFieldSx={{
            width: '158px',
            '& .MuiInputBase-root': {
              height: '32px',
              fontSize: '12px',
            },
          }}
          selected={startDate}
          onChange={(date) => onStartDateSelection(date)}
          selectsStart
          onClear={() => onStartDateSelection(null)}
        />
        <Typography fontSize="12px">To</Typography>
        <DatePickerInputField
          textFieldSx={{
            width: '158px',
            '& .MuiInputBase-root': {
              height: '32px',
              fontSize: '12px',
            },
          }}
          selected={endDate}
          onChange={(date) => onEndDateSelection(date)}
          selectsEnd
          onClear={() => onEndDateSelection(null)}
        />
      </Box>
    </TrackerFilterPopoverGrid>
  );
}
